import classNames from 'classnames'
import './Card.scss'

type PaddingSize = '3xl' | '2xl' | 'xl' | 'lg' | 'md' | 'sm' | 'xs'

interface CardProps {
  children: React.ReactNode
  className?: string
  padding?: PaddingSize
  paddingX?: PaddingSize
  paddingY?: PaddingSize
  'data-testid'?: string
}

export function Card({
  children,
  padding = 'xl',
  paddingX,
  paddingY,
  className = '',
  'data-testid': dataTestId
}: React.PropsWithChildren<CardProps>) {
  return (
    <div
      data-testid={dataTestId}
      className={classNames('core-ux-card', className, {
        [`padding-${padding}`]: padding,
        [`padding-x-${paddingX}`]: paddingX,
        [`padding-y-${paddingY}`]: paddingY
      })}>
      {children}
    </div>
  )
}
